import React from 'react';
import { useRoutes } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';

import { ThemeProvider } from '@material-ui/core';

import theme from '~/theme';
import routes from '~/routes';
import GlobalStyles from '~/components/shared/GlobalStyles';
import AuthGate from '~/components/shared/AuthGate';

import './fonts/poppins/stylesheet.css';
import './fonts/montserrat/stylesheet.css';
import './fonts/inter/inter.css';
import './assets/generated/css/variables.css';

const App = () => {
  const routing = useRoutes(routes());
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <AuthGate>{routing}</AuthGate>
    </ThemeProvider>
  );
};

export default App;
